import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsUp24Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconThumbsUp24Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 10a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h1V10zm2.5-1.108V20h7.226a3 3 0 0 0 2.629-1.554l2.2-4c1.1-2-.347-4.446-2.629-4.446H14.5l.532-4.273c.182-1.456-1.62-2.28-2.602-1.19z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsUp24Filled);
